import { createFileRoute } from '@tanstack/react-router';

import { NotificationDetailsPage } from '@/features/notifications/NotificationDetailsPage';

function NotificationDetailsRoute() {
  const { notificationId } = Route.useParams();
  return <NotificationDetailsPage notificationId={notificationId} />;
}

export const Route = createFileRoute('/admin/_app/notifications/$notificationId/')({
  component: NotificationDetailsRoute,
});
